import ReactDOM from "react-dom/client";
import App from "@/App";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import zhCN from "dayjs/locale/zh-cn";

dayjs.extend(relativeTime);
dayjs.locale(zhCN);

ReactDOM.createRoot(document.getElementById("root")!).render(<App />);